import React, { useEffect, useRef, useState } from 'react';
import { useFormikContext } from 'formik';
import { Popper, ClickAwayListener } from '@mui/material';
import get from 'lodash/get';
import { IconsGrid, StylePickerBtn, StylePickerPaper, StyledTextField, IconButton, TextColorContainer, ColorIndicator, ArrowDropDown, IconButtonColor, } from './StylePicker.styles';
import { FormatBold, FormatItalic, FormatUnderlined, StrikethroughS, TextFormat, } from '@mui/icons-material';
import ColorPicker from '../ColorPicker';
const TextColorIcon = (props) => {
    return (React.createElement(IconButtonColor, { size: "small" },
        React.createElement(TextColorContainer, null,
            React.createElement(TextFormat, { fontSize: "medium" }),
            React.createElement(ColorIndicator, { color: props.color ?? '#000000' }),
            React.createElement(ArrowDropDown, { fontSize: "small" }))));
};
const styleIcons = [
    { key: 'bold', icon: React.createElement(FormatBold, { fontSize: "small" }) },
    { key: 'italic', icon: React.createElement(FormatItalic, { fontSize: "small" }) },
    { key: 'underline', icon: React.createElement(FormatUnderlined, { fontSize: "small" }) },
    { key: 'lineThrough', icon: React.createElement(StrikethroughS, { fontSize: "small" }) },
];
export const StylePicker = ({ name, value, onChange, placement, dataCy, }) => {
    const { values, setFieldValue } = useFormikContext();
    const anchorRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [style, setStyle] = useState(() => {
        if (value)
            return value;
        if (name)
            return get(values, name);
        return { fontColor: '#000000' };
    });
    const handleClickAway = (e) => {
        if (anchorRef.current &&
            anchorRef.current.contains(e.target)) {
            return;
        }
        setIsOpen(false);
    };
    const handleClickStyle = (key) => {
        const newStyle = {
            ...style,
            [key]: !style?.[key],
        };
        if (name)
            setFieldValue(name, newStyle);
        setStyle(newStyle);
        onChange?.(newStyle);
    };
    useEffect(() => {
        if (value) {
            setStyle(value);
        }
    }, [value]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StylePickerBtn, { ref: anchorRef },
            React.createElement(StyledTextField, { "data-cy": dataCy, variant: "outlined", size: "small", margin: "none", inputProps: {
                    contentEditable: false,
                    onClick: () => setIsOpen(!isOpen),
                }, value: 'T', "$style": style })),
        React.createElement(Popper, { open: isOpen, anchorEl: anchorRef.current, placement: placement }, () => (React.createElement(ClickAwayListener, { onClickAway: handleClickAway },
            React.createElement(StylePickerPaper, null,
                React.createElement(IconsGrid, null,
                    styleIcons.map(s => (React.createElement(IconButton, { key: s.key, size: "small", selected: !!style[s.key], onClick: () => handleClickStyle(s.key) }, s.icon))),
                    React.createElement(ColorPicker, { name: "color", label: "Series Color", placement: "bottom-start", onChange: newColor => {
                            const newStyle = {
                                ...style,
                                fontColor: newColor,
                            };
                            if (name)
                                setFieldValue(name, newStyle);
                            setStyle(newStyle);
                            onChange?.(newStyle);
                        } },
                        React.createElement(TextColorIcon, { color: style.fontColor })))))))));
};
export default StylePicker;
